import SurveyorLanding from "./SurveyorLanding";

export default SurveyorLanding;
